import { Mail } from 'lucide-react'

const Footer = () => {
  return (
    <footer className="mt-auto py-8 border-t border-primary/10">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex flex-col md:flex-row justify-between items-center gap-4">
          {/* 左侧版权信息 */}
          <div className="text-gray-500 text-sm">
            <p>© {new Date().getFullYear()} PlayWithAI. All rights reserved.</p>
          </div>

          {/* 中间链接 */}
          <div className="flex items-center gap-6 text-sm text-gray-500">
            <a 
              href="/terms" 
              className="hover:text-primary transition-colors duration-300"
            >
              服务条款
            </a>
            <a 
              href="/privacy" 
              className="hover:text-primary transition-colors duration-300"
            >
              隐私政策
            </a>
            <a 
              href="/about" 
              className="hover:text-primary transition-colors duration-300"
            >
              关于我们
            </a>
          </div>

          {/* 右侧联系方式 */}
          <div className="flex items-center gap-2 text-sm text-gray-500">
            <Mail className="w-4 h-4" />
            <a 
              href="mailto:contact@playwithai.fun"
              className="hover:text-primary transition-colors duration-300"
            >
              contact@playwithai.fun
            </a>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer 